import {DataFrameColumnDef, DataFrameSpec} from 'data-frames/DataFrameTypes';
import findColumn from 'data-frames/util/findColumn';

import ConvertToChartPropsException from '../ConvertToChartPropsException';

export const MISSING_AXIS_COLUMN_ERROR_MESSAGE = 'Invalid column specified for one or more parameters.';

export default function findAxisColumn(
  dataFrameSpec: Pick<DataFrameSpec, 'columns'>,
  columnSystemName: string
): DataFrameColumnDef {
  const column = findColumn(dataFrameSpec, columnSystemName);

  if (column == null) {
    throw new ConvertToChartPropsException(MISSING_AXIS_COLUMN_ERROR_MESSAGE);
  }

  return column;
}
